import { cn } from '@/shared/utilities/cn';
import { ArrowBack } from '@mui/icons-material';
import { Button, type ButtonProps } from '@mui/material';
import { useRouter } from '@tanstack/react-router';

interface IButtonAction extends ButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
  hide?: boolean;
  onFileSelect?: (file: File) => void;
  label?: string;
}

const BackButton: React.FC<IButtonAction> = ({ className, ...props }) => {
  if (!props.onClick) {
    const router = useRouter();

    return (
      <Button
        {...props}
        className={cn(className, 'mex:!min-w-24')}
        onClick={() => router.history.back()}
        variant='outlined'
        color='primary'
        startIcon={<ArrowBack />}
      >
        Trở về
      </Button>
    );
  }

  return (
    <Button
      {...props}
      className={cn(className, 'mex:!min-w-24')}
      variant='outlined'
      color='primary'
      startIcon={<ArrowBack />}
    >
      Trở về
    </Button>
  );
};

export { BackButton };
